import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[sportSlug]/page.tsx");
